import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { aplicacionesCargosEnum } from 'views/Tramites/GPM/enums';

const TIPOS_COMUNES = [
  aplicacionesCargosEnum.FIJO,
  aplicacionesCargosEnum.FORMULA,
  aplicacionesCargosEnum.PORCENTAJE,
  aplicacionesCargosEnum.SQL_FUNCTION,
];

export const TIPOS_DE_APLICACION_ACCESORIO_AUTODETERMINABLE = [...TIPOS_COMUNES];
export const TIPOS_DE_APLICACION_DETERMINABLE = [
  aplicacionesCargosEnum.CAPTURABLE,
  aplicacionesCargosEnum.TARIFA,
  aplicacionesCargosEnum.MULTIPLO,
  ...TIPOS_COMUNES,
];
export const TIPOS_DE_APLICACION_AUTODETERMINABLE = [
  aplicacionesCargosEnum.CAPTURABLE,
  aplicacionesCargosEnum.TARIFA,
  aplicacionesCargosEnum.MULTIPLO,
  ...TIPOS_COMUNES,
];

const TooltipTipoDeAplicacion = ({ concepto, esAccesorio }) => {
  const { tiposDeAplicacionCargos } = useSelector((state) => state.catalogs);

  const esDeterminable = concepto?.naturaleza_de_ingresos === 1;

  const obtenerDescripcion = (lista) => lista.map((e) => (
    <li key={e}>{tiposDeAplicacionCargos.find((i) => i.id === e)?.descripcion}</li>
  ));

  if (!concepto) return null;

  return (
    <>
      <p>
        Concepto seleccionado:
        {' '}
        <strong>{concepto.descripcion}</strong>
        {' '}
        (
        {esDeterminable ? 'Determinable' : 'Autodeterminable'}
        )
      </p>
      <p className={!esAccesorio && esDeterminable ? 'bold' : ''}>
        Si el concepto de ingresos es determinable, el tipo de aplicación puede ser:
        <ul>{obtenerDescripcion(TIPOS_DE_APLICACION_DETERMINABLE)}</ul>
      </p>
      <p className={!esAccesorio && !esDeterminable ? 'bold' : ''}>
        Si el concepto de ingresos es autodeterminable, el tipo de aplicación puede ser:
        <ul>{obtenerDescripcion(TIPOS_DE_APLICACION_AUTODETERMINABLE)}</ul>
      </p>
      <p className={esAccesorio && !esDeterminable ? 'bold' : ''}>
        Si el concepto de ingresos es autodeterminable y el cargo es un accesorio, el tipo de
        aplicación puede ser:
        <ul>{obtenerDescripcion(TIPOS_DE_APLICACION_ACCESORIO_AUTODETERMINABLE)}</ul>
      </p>
    </>
  );
};

TooltipTipoDeAplicacion.propTypes = {
  concepto: PropTypes.shape({
    descripcion: PropTypes.string,
    naturaleza_de_ingresos: PropTypes.number,
  }),
  esAccesorio: PropTypes.bool.isRequired,
};

TooltipTipoDeAplicacion.defaultProps = {
  concepto: null,
};

export default TooltipTipoDeAplicacion;
